module.exports = __webpack_public_path__ + "img/arrows-turn-to-dots.b2f3a0af.svg";